module.exports = __webpack_public_path__ + "static/media/yewu-cj1.5974aa1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-cj1.png
// module id = 594
// module chunks = 0